import { Component, OnInit } from '@angular/core';
import { Share } from '@capacitor/share';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { FirebaseCrashlyticsService } from '@shared/services/firebase-crashlytics.service';

@Component({
  selector: 'app-liked-by-selected',
  templateUrl: './liked-by-selected.component.html',
  styleUrls: ['./liked-by-selected.component.scss'],
})
export class LikedBySelectedComponent implements OnInit {
  public userId: any;

  constructor(
    public firebaseCrashlytics: FirebaseCrashlyticsService,
    public translate: TranslateService, private navParams: NavParams, private modalController: ModalController) { }

  ngOnInit() {
    this.userId = this.navParams.get('userId');
  }

  goBack() {
    this.modalController.dismiss({
      'dismissed': true
    });
  }


  profileShare() {
    Share.share({
      text: this.translate.instant('checkVegglyMsg') + 'https://app.veggly.net/?referralUserId=' + this.userId,
      title: this.translate.instant('checkVegglyTitle')
    }).then((sucess) => {
      console.log('share succesfull: ' + JSON.stringify(sucess));
    }).catch((error) => {
      this.firebaseCrashlytics.log('share unsuccesfull: ' + JSON.stringify(error));
    });
  }

}
